<template>
<loader v-bind="{ loading }">
  <page-navigation :title="environment.name">
    <template #subtitle>
      <h6 class="subtitle is-6">
        <small class="has-text-grey">Last active {{ environment.updated_at | asCalendar }}, </small> 
        <router-link :to="{
          name: 'app-manager',
          params: {
            app: environment.app_id
          }
        }">
          {{ environment.app.name }}
        </router-link>
      </h6>
    </template>
    <template #right>
      <router-link class="button" :to="{ name: 'environment-edit', params: $route.params}">
        <icon icon="cog"/>
      </router-link>
    </template>
  </page-navigation>  
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'environment-manager', params: $route.params}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'environment-attributes', params: $route.params}">
        <a>Attributes</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'environment-software', params: $route.params}">
        <a>Software</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'environment-routes', params: $route.params}">
        <a>Routes</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'environment-events', params: $route.params}">
        <a>Event Log</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'environment-middleware', params: $route.params}">
        <a>Middleware</a>
      </router-link>
    </ul>
  </div>

  <router-view />
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    loading: true
  }),
  
  beforeCreate() {
    this.$store.dispatch('environment/loadEnv', this.$route.params.environment).then(() => {
      this.loading = false
    })
  },

  computed: mapGetters('environment', [
    'environment'
  ])

}
</script>